<template>
  <div class="trainer">
    <div class="example">
      <span class="factor">{{ factorA }}</span>
      <span class="operator">×</span>
      <span class="factor">{{ factorB }}</span>
      <span class="operator">=</span>
      <input
        ref="answerInput"
        v-model="userAnswer"
        type="number"
        inputmode="numeric"
        class="answer-input"
        :disabled="answered"
        @keyup.enter="checkAnswer"
      />
    </div>

    <button
      v-if="!answered"
      class="btn-check"
      :disabled="userAnswer === ''"
      @click="checkAnswer"
    >
      Проверить
    </button>

    <div v-if="answered" class="result" :class="resultClass">
      <div class="result-icon">{{ isCorrect ? "✓" : "✗" }}</div>
      <div class="result-text">
        <template v-if="isCorrect">Правильно!</template>
        <template v-else>
          Неправильно. Правильный ответ: <strong>{{ correctAnswer }}</strong>
        </template>
      </div>
      <button class="btn-next" @click="loadExample">Следующий пример</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MathTrainer',
  data () {
    return {
      factorA: 2,
      factorB: 2,
      userAnswer: '',
      answered: false,
      isCorrect: false,
      correctAnswer: 0,
      loading: false
    }
  },
  computed: {
    resultClass () {
      return this.isCorrect ? 'result-correct' : 'result-wrong'
    }
  },
  mounted () {
    this.loadExample()
  },
  methods: {
    async loadExample () {
      this.loading = true
      try {
        const res = await fetch(
          `${process.env.VUE_APP_API_URL}/api/get_example.php`
        )
        const data = await res.json()
        this.factorA = data.factor_a
        this.factorB = data.factor_b
        this.userAnswer = ''
        this.answered = false
        this.isCorrect = false
        this.correctAnswer = 0
        this.$nextTick(() => {
          if (this.$refs.answerInput) this.$refs.answerInput.focus()
        })
      } catch (e) {
        console.error('Ошибка загрузки примера', e)
      } finally {
        this.loading = false
      }
    },
    async checkAnswer () {
      if (this.userAnswer === '' || this.answered) return

      try {
        const res = await fetch(
          `${process.env.VUE_APP_API_URL}/api/check_answer.php`,
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              factor_a: this.factorA,
              factor_b: this.factorB,
              user_answer: parseInt(this.userAnswer, 10)
            })
          }
        )
        const data = await res.json()

        this.isCorrect = data.is_correct
        this.correctAnswer = data.correct_answer
        this.answered = true

        if (this.isCorrect) {
          setTimeout(() => this.loadExample(), 1500)
        }
      } catch (e) {
        console.error('Ошибка проверки', e)
      }
    }
  }
}
</script>

<style scoped>
.trainer {
  background: #fff;
  border-radius: 16px;
  padding: 32px 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.example {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 32px;
  flex-wrap: wrap;
}

.factor {
  font-size: 48px;
  font-weight: 700;
  color: #2d3748;
  min-width: 60px;
  text-align: center;
}

.operator {
  font-size: 40px;
  font-weight: 600;
  color: #a0aec0;
}

.answer-input {
  width: 120px;
  height: 72px;
  font-size: 40px;
  font-weight: 700;
  text-align: center;
  border: 3px solid #cbd5e0;
  border-radius: 12px;
  outline: none;
  color: #2d3748;
  transition: border-color 0.2s;
}

.answer-input:focus {
  border-color: #4299e1;
}

.answer-input:disabled {
  background: #f7fafc;
}

.btn-check {
  width: 100%;
  padding: 18px;
  font-size: 20px;
  font-weight: 600;
  color: #fff;
  background: #4299e1;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-check:hover:not(:disabled) {
  background: #3182ce;
}

.btn-check:disabled {
  background: #cbd5e0;
  cursor: not-allowed;
}

.result {
  text-align: center;
  padding: 16px;
  border-radius: 12px;
}

.result-correct {
  background: #f0fff4;
  border: 2px solid #48bb78;
}

.result-wrong {
  background: #fff5f5;
  border: 2px solid #f56565;
}

.result-icon {
  font-size: 56px;
  line-height: 1;
  margin-bottom: 8px;
}

.result-correct .result-icon {
  color: #48bb78;
}

.result-wrong .result-icon {
  color: #f56565;
}

.result-text {
  font-size: 20px;
  margin-bottom: 16px;
}

.btn-next {
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  background: #2d3748;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.btn-next:hover {
  background: #1a202c;
}

@media (max-width: 480px) {
  .trainer {
    padding: 20px 16px;
  }
  .factor {
    font-size: 36px;
    min-width: 44px;
  }
  .operator {
    font-size: 30px;
  }
  .answer-input {
    width: 90px;
    height: 56px;
    font-size: 30px;
  }
  .btn-check {
    padding: 14px;
    font-size: 18px;
  }
}
</style>
